export type ParseResult = { valid: true; obj: Record<string, string> } | { valid: false; error: string };

export type Row = { id: string; key: string; value: string };

export function tryParse(text: string): ParseResult {
  const trimmed = text?.trim();
  if (!trimmed) return { valid: true, obj: {} };
  try {
    const obj = JSON.parse(trimmed);
    if (typeof obj !== 'object' || obj === null || Array.isArray(obj)) {
      return { valid: false, error: 'JSON must be an object of key-value pairs.' };
    }
    if (Object.values(obj).some(v => typeof v !== 'string')) {
      return { valid: false, error: 'Values must be strings.' };
    }
    return { valid: true, obj: obj as Record<string, string> };
  } catch (e) {
    return { valid: false, error: (e as Error).message.replace(/^JSON\.parse:\s*/, '') };
  }
}

export function rowsToJsonString(rows: Row[]): string {
  const obj: Record<string, string> = {};
  rows.forEach(r => {
    if (r.key.trim()) obj[r.key.trim()] = r.value;
  });
  return Object.keys(obj).length ? JSON.stringify(obj) : '';
}

export function jsonStringToRows(jsonString: string): Row[] {
  const result = tryParse(jsonString);
  if (!result.valid || !Object.keys(result.obj).length) {
    return [{ id: crypto.randomUUID(), key: '', value: '' }];
  }
  return Object.entries(result.obj).map(([key, value]) => ({ id: crypto.randomUUID(), key, value: String(value) }));
}
